import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { TimeSeriesData } from '../types/rwanda';

interface TimeseriesChartProps {
  data: TimeSeriesData[];
  analysisType: string;
}

const TimeseriesChart: React.FC<TimeseriesChartProps> = ({ data, analysisType }) => {
  // Transform data for recharts
  const chartData = data.map(item => ({
    date: new Date(item.date).toLocaleDateString(),
    ...item.values
  }));

  // Get available indices
  const indices = data.length > 0 ? Object.keys(data[0].values) : [];
  
  // Color map for different indices
  const colorMap: Record<string, string> = {
    NDVI: '#22c55e',
    EVI: '#3b82f6',
    SAVI: '#f59e0b',
    NDBI: '#ef4444',
    NBR: '#8b5cf6'
  };

  if (data.length === 0) {
    return (
      <div className="w-full h-64 flex items-center justify-center bg-gray-50 rounded-lg">
        <div className="text-gray-500">No data available for chart</div>
      </div>
    );
  }

  return (
    <div className="w-full h-64 bg-gray-50 rounded-lg p-4">
      <h4 className="text-sm font-medium text-gray-700 mb-2">
        Time Series - {analysisType}
      </h4>
      <div className="text-xs text-gray-500">
        Chart component placeholder - {data.length} data points
      </div>
      <div className="mt-2 text-xs">
        Date range: {data[0]?.date} to {data[data.length - 1]?.date}
      </div>
      <ResponsiveContainer width="100%" height="100%">
        <LineChart data={chartData}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis 
            dataKey="date" 
            tick={{ fontSize: 12 }}
            angle={-45}
            textAnchor="end"
            height={80}
          />
          <YAxis tick={{ fontSize: 12 }} />
          <Tooltip />
          <Legend />
          {indices.map(index => (
            <Line
              key={index}
              type="monotone"
              dataKey={index}
              stroke={colorMap[index] || '#6b7280'}
              strokeWidth={2}
              dot={{ r: 3 }}
            />
          ))}
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default TimeseriesChart;